<template>
  <div class="py-6 px-8">
    <h-header back="../hosts" />

    <v-card v-if="Object.keys(hostOnboardingStepData).length" class="pa-6" elevation="0">
      <div class="mb-6" v-if="disapproved">
        <h3 class="mb-4 error--text">O Host está reprovado</h3>

        <v-row no-gutters>
          <v-col>
            <h6 class="text-uppercase  error--text">Reprovado em</h6>
          </v-col>
        </v-row>
        <v-row no-gutters>
          <v-col>
            <span class="error--text">
              {{formatDate(hostOnboardingStepData.date_created)}}
            </span>
          </v-col>
        </v-row>

        <v-row no-gutters class="mt-4">
          <v-col>
            <h6 class="text-uppercase error--text">Motivo</h6>
          </v-col>
        </v-row>
        <v-row no-gutters>
          <v-col>
            <span class="error--text">
              {{
                hostOnboardingStepData.disapprove_type ?
                $t(`hostOnboarding.disapproveTypes.${hostOnboardingStepData.disapprove_type}`) :
                '---'
              }}
            </span>
          </v-col>
        </v-row>

        <v-row no-gutters class="mt-4">
          <v-col>
            <h6 class="text-uppercase error--text">Comentário</h6>
          </v-col>
        </v-row>
        <v-row no-gutters>
          <v-col>
            <span class="error--text">
              {{hostOnboardingStepData.disapprove_description ? hostOnboardingStepData.disapprove_description : '---'}}
            </span>
          </v-col>
        </v-row>
      </div>

      <v-divider v-if="disapproved" class="my-5" />

      <h4>Mudar passo</h4>
      <v-row>
        <v-col cols="4">
          <v-select
            :items="availableSteps"
            v-model="selectedStep"
            @change="this.openChangeHostOnboardingStep"
            hide-selected
            outlined
          >
            <template v-slot:item="{item}">
              {{ $t(`hostOnboarding.types.${item}`) }}
            </template>
            <template v-slot:selection="{item}">
              {{ $t(`hostOnboarding.types.${item}`) }}
            </template>
          </v-select>
        </v-col>
      </v-row>

      <div>
        <h3 class="mb-4">{{$t('hostOnboarding.types.REGISTRATION')}}</h3>

        <div v-if="Object.keys(host).length">
          <h4>
            Dados
          </h4>
          <v-row>
            <v-col>
              <h6 class="text-uppercase grey--text">
                {{ $t('host.label.name') }}
              </h6>
              <span class="font-weight-medium">
                {{ host.name }}
              </span>
            </v-col>
          </v-row>

          <v-row>
            <v-col>
              <h6 class="text-uppercase grey--text">
                {{ $t('host.label.username') }}
              </h6>
              <span class="font-weight-medium">
                {{ host.username }}
              </span>
            </v-col>
          </v-row>

          <v-row>
            <v-col cols="3">
              <h6 class="text-uppercase grey--text">
                {{ $t('host.label.cpf') }}
              </h6>
              <span class="font-weight-medium">
                {{ host.cpf ? formatDocument(host.cpf) : '---' }}
              </span>
            </v-col>

            <v-col cols="3">
              <h6 class="text-uppercase grey--text">
                {{ $t('host.label.rg') }}
              </h6>
              <span class="font-weight-medium">
                {{ host.rg ? host.rg : '---' }}
              </span>
            </v-col>
          </v-row>
        </div>

        <div v-if="Object.keys(registrationStep).length">
          <h4>
            Histórico pessoal
          </h4>
          <v-row>
            <v-col cols="12" sm="6">
              <v-alert v-if="!Object.keys(hostBackgroundCheck).length" color="orange lighten-5" class="warning--text">
                <div class="d-flex ma-2 my-4">
                  <v-icon color="warning">mdi-information-outline</v-icon>
                  <span class="ml-4">Verificação de histórico pessoal do Host ainda não foi feita.</span>
                </div>
              </v-alert>

              <div class="d-flex justify-start align-center" :class="{'ma-8': hostBackgroundCheck.status == 'COMPLETED'}" v-if="Object.keys(hostBackgroundCheck).length">
                <v-alert v-if="hostBackgroundCheck.status != 'COMPLETED'" color="blue lighten-5" class="primary--text">
                  <div class="d-flex ma-2 my-4">
                    <v-icon color="primary">mdi-timer-sand</v-icon>
                    <span class="ml-4">Verificação de histórico pessoal do Host está em andamento</span>
                  </div>
                </v-alert>

                <div v-if="hostBackgroundCheck.status == 'COMPLETED'">
                  <v-progress-circular
                    :rotate="90"
                    :size="120"
                    :width="10"
                    :value="hostScore * 10"
                    :color="hostScoreColor"
                  >
                    <div>
                      <span class="text-h4 font-weight-bold d-flex justify-center">
                        {{ leadingZero(hostScore, 2)}}
                      </span>
                      <span class="grey--text">
                        pontos
                      </span>
                    </div>

                  </v-progress-circular>
                </div>

                <div v-if="hostBackgroundCheck.status == 'COMPLETED'" class="d-block ml-4">
                  <span>
                    Nota do histórico <br>
                    pessoal do Host
                  </span>
                  <span class="d-flex justify-start primary--text mt-2 pointer" @click="showFile(hostBackgroundCheck.truora_attachment.url)">
                    Baixar detalhes <v-icon color="primary" class="ml-1" small>mdi-download</v-icon>
                  </span>
                </div>
              </div>
            </v-col>
          </v-row>

          <h4>
            Anexos
          </h4>
          <v-row>
            <v-col v-if="registrationStep.files.length">
              <div class="my-4" v-for="file in registrationStep.files" :key="file.id">
                <v-row no-gutters>
                  <v-col>
                    <span @click="showFile(file.externalURL)" class="pointer primary--text text-decoration-underline">
                      <v-icon class="mb-1 mr-1" color="primary" small >
                        mdi-download
                      </v-icon>
                      {{`${file.filename}`}}
                    </span>
                    <span class="body-2 font-weight-medium ml-1">
                      {{formatDate(file.date_created)}}
                    </span>
                  </v-col>
                </v-row>
              </div>
            </v-col>
            <v-col v-else>
              <span class="grey--text">
                ---
              </span>
            </v-col>
          </v-row>

          <h4>Comentários</h4>
          <v-row>
            <v-col v-if="registrationStep.feedbacks.length" cols="12" sm="8" lg="4">
              <HostOnboardingFeedbacks :host-name="host.name" :feedbacks="registrationStep.feedbacks" />
            </v-col>
            <v-col v-else>
              <span class="grey--text">
                ---
              </span>
            </v-col>
          </v-row>
        </div>
      </div>

      <div v-if="Object.keys(courseStep).length">
        <v-divider class="my-5" />
        <h3 class="mb-4">
          {{ $t('hostOnboarding.types.COURSE') }}
        </h3>
        <v-row>
          <v-col>
            <h6 class="text-uppercase grey--text">
              {{ $t('hostOnboarding.label.progress') }}
            </h6>
            <span class="font-weight-medium">
              {{ $t(`hostOnboarding.coursePercentage.${courseStep.course_percentage}`) }}
            </span>
          </v-col>
        </v-row>
        <v-row>
          <v-col>
            <h6 class="text-uppercase grey--text">
              {{ $t('hostOnboarding.label.name') }}
            </h6>
            <span class="font-weight-medium">
              {{ `Curso de ${$t('type.' + courseStep.course.type)}` }}
            </span>
          </v-col>
        </v-row>
        <v-row>
          <v-col>
            <h6 class="text-uppercase grey--text">
              {{ $t('hostOnboarding.label.description') }}
            </h6>
            <span class="font-weight-medium">
              {{ courseStep.course.description ? courseStep.course.description : '---' }}
            </span>
          </v-col>
        </v-row>
        <v-row class="mb-2">
          <v-col>
            <h6 class="text-uppercase grey--text">
              {{ $t('hostOnboarding.label.link') }}
            </h6>
            <span @click="showFile(courseStep.course.link)" class="pointer primary--text text-decoration-underline">
              {{ courseStep.course.link }}
            </span>
          </v-col>
        </v-row>
        <h4>
          Anexos
        </h4>
        <v-row>
          <v-col v-if="courseStep.files.length">
            <div class="my-4" v-for="file in courseStep.files" :key="file.id">
              <v-row no-gutters>
                <v-col>
                  <span @click="showFile(file.externalURL)" class="pointer primary--text text-decoration-underline">
                    <v-icon class="mb-1 mr-1" color="primary" small >
                      mdi-download
                    </v-icon>
                    {{`${file.filename}`}}
                  </span>
                  <span class="body-2 font-weight-medium ml-1">
                    {{formatDate(file.date_created)}}
                  </span>
                </v-col>
              </v-row>
            </div>
          </v-col>
          <v-col v-else>
            <span class="grey--text">
              ---
            </span>
          </v-col>
        </v-row>

        <h4>Comentários</h4>
        <v-row>
          <v-col v-if="courseStep.feedbacks.length" cols="12" sm="8" lg="4">
            <HostOnboardingFeedbacks :host-name="host.name" :feedbacks="courseStep.feedbacks" />
          </v-col>
          <v-col v-else>
            <span class="grey--text">
              ---
            </span>
          </v-col>
        </v-row>
      </div>

      <div v-if="Object.keys(agreementStep).length">
        <v-divider class="my-5" />
        <h3 class="mb-4">
          {{ 'Contrato & Termos de uso' }}
        </h3>
        <v-row no-gutters v-for="agreement in agreementStep.agreements" :key="agreement.id">
          <v-col>
            <span @click="openShowAgreementModal(agreement.type)" class="d-flex justify-start primary--text mt-2 pointer">
                {{ agreement.type == 'CONTRACT' ? 'Contrato' : agreement.type == 'TERMS' ? 'Termos de uso' : '---' }}
                <v-icon color="primary" class="ml-1" small>mdi-open-in-new</v-icon>
              </span>
          </v-col>
        </v-row>
        <v-row>
          <v-col>
            <h6 class="text-uppercase grey--text">
              Aceitos em
            </h6>
            <span class="font-weight-medium">
              {{ Object.keys(doneStep).length ? formatDateWithoutTime(doneStep.date_created) : '---' }}
            </span>
          </v-col>
        </v-row>
      </div>
    </v-card>

    <v-card v-else class="pa-6" elevation="0">
      <v-row v-if="!isLoading && !Object.keys(hostOnboardingStepData).length">
        <v-col>
          <EmptyState />
        </v-col>
      </v-row>
    </v-card>

    <ModalHostOnboardingStepChange :host="host" />
    <ModalShowAgreement />
  </div>
</template>

<script>
import { mapGetters, mapActions } from 'vuex'
import { formatDocument } from '@/util/document'
import { catalogDate, catalogDateWithoutTime, zeroPad } from '@/util/catalog'

import EmptyState from '@/components/app/EmptyState'
import ModalHostOnboardingStepChange from '@/components/host/modals/ModalHostOnboardingStepChange'
import ModalShowAgreement from '@/components/host/modals/ModalShowAgreement'
import HostOnboardingFeedbacks from '@/components/host/HostOnboardingFeedbacks'

export default {
  name: 'HostOnboardingDetails',

  components: {
    ModalHostOnboardingStepChange,
    EmptyState,
    ModalShowAgreement,
    HostOnboardingFeedbacks
  },

  data() {
    return {
      formatDocument,
      currentTab: 0,
      hostId: this.$router.currentRoute.params.id,
      registrationStep: {},
      courseStep: {},
      agreementStep: {},
      doneStep: {},
      leadingZero: zeroPad,
      formatDate: catalogDate,
      formatDateWithoutTime: catalogDateWithoutTime,
      availableSteps: [],
      selectedStep: null,
      currentAgreement: null,
    }
  },

  watch: {
    hostOnboardingStepsData() {
      this.divideSteps()
    },

    hostOnboardingStepData(newValue) {
      this.selectedStep = newValue.type
    }
  },

  computed: {
    ...mapGetters(['isLoading', 'host', 'hostBackgroundCheck', 'hostOnboardingStepsData', 'hostOnboardingStepData']),

    hostScore() {
      return Math.ceil((this.hostBackgroundCheck?.score) * 10)
    },

    hostScoreColor() {
      return this.hostScore <  5 ? 'error' : this.hostScore < 8 ? 'warning' : 'success'
    },

    disapproved() {
      return this.hostOnboardingStepData.type == 'DISAPPROVED'
    },

  },

  methods: {
    ...mapActions(['fetchHostOnboardingStepsData', 'fetchHostOnboardingStepData', 'fetchHostBackgroundCheck', 'fetchHost', 'openModal']),

    showFile(url) {
      window.open(url, '_blank')
    },

    divideSteps() {
      this.hostOnboardingStepsData.forEach((step) => {
        if (step.type != 'DISAPPROVED') {
          this.availableSteps.push(step.type)
        }
        switch(step.type) {
          case "REGISTRATION":
            this.registrationStep = step
            this.sortRegistrationFeedbackAndFilesByDate()
            break;
          case "COURSE":
            this.courseStep = step
            this.sortCourseFeedbackAndFilesByDate()
            break;
          case "AGREEMENT":
            this.agreementStep = step
            break;
          case "DONE":
            this.doneStep = step
            break;
        }
      })
    },

    sortCourseFeedbackAndFilesByDate() {
      if (this.courseStep.feedbacks.length) {
        this.courseStep.feedbacks = this.courseStep.feedbacks.sort((a,b) => this.sortByDateCreated(a,b))
      }
      if (this.courseStep.files.length) {
        this.courseStep.files = this.courseStep.files.sort((a,b) => this.sortByDateCreated(a,b))
      }
    },

    sortRegistrationFeedbackAndFilesByDate() {
      if (this.registrationStep.feedbacks.length) {
        this.registrationStep.feedbacks = this.registrationStep.feedbacks.sort((a,b) => this.sortByDateCreated(a,b))
      }
      if (this.registrationStep.files.length) {
        this.registrationStep.files = this.registrationStep.files.sort((a,b) => this.sortByDateCreated(a,b))
      }
    },

    sortByDateCreated(a,b) {
      return new Date(b.date_created) - new Date(a.date_created)
    },

    openChangeHostOnboardingStep() {
      this.openModal('HOST_ONBOARDING_CHANGE_STEP')
    },

    openShowAgreementModal(currentAgreement) {
      this.currentAgreement = currentAgreement
      this.openModal('SHOW_HOST_ONBOARDING_AGREEMENT')
    }
  },

  async mounted() {
    await this.fetchHostOnboardingStepsData(this.hostId)
    await this.fetchHost(this.hostId)
    await this.fetchHostBackgroundCheck(this.hostId)
    await this.fetchHostOnboardingStepData(this.hostId)
  },
}
</script>

<style scoped>
  .pointer {
    cursor: pointer !important
  }
</style>
